import Vue from "vue";
import VueRouter from "vue-router";
import AppConfigClass from "../include/config";

const config = new AppConfigClass();

import dev from "./dev";
import feedback from "./feedback";
import clinical from "./clinical";
import tests from "./tests";
import forms from "./forms";
import files from "./files";
import reports from "./reports";
import attendance from "./attendance";
import messages from "./messages";
import settings from "./settings";
import formeditor from "./formeditor";
import clinicalcases from "./clinicalcases";
import timetables from "./timetables";
import thirdparty from "./thirdparty";
import users from "./users";
import workflows from "./workflows";
import reflections from "./reflections";
import curriculummapping from "./curriculummapping";
import externalsignoff from "./externalsignoff";
import placements from "./placements";
import timeline from "./timeline";

import SessionManager from "../modules/session/sessionManager";

Vue.use(VueRouter);

const routes = [
	...(config.hasModule('dev') ? dev : []),
	...feedback,
	...clinical,
	...tests,
	...forms,
	...files,
	...reports,
	...attendance,
	...messages,
	...settings,
	...formeditor,
	...clinicalcases,
	...timetables,
	...thirdparty,
	...users,
	...workflows,
	...curriculummapping,
	...reflections,
	...externalsignoff,
	...placements,
    ...timeline,
	{
		path: "/",
		// Some vue router navigation actions with no 'from' route set 'from' to the root path.
		// 'name' is set here so we can distinguish between a null-ish 'from' and a dashboard 'from'.
		name: 'dashboard',	
		component: () => import("../views/Dashboard.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: '*',
		component: () => import("../views/NotFoundComponent.vue"),
		meta: {
			hasmainmenu: true
		}
	}
];

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes,
});

router.beforeEach((to, from, next) => {
	SessionManager.navigate(from, to)
	next()
})

export default router;
